import { render, staticRenderFns } from "./ProgramSupportCreate.vue?vue&type=template&id=104940bf"
import script from "./ProgramSupportCreate.vue?vue&type=script&lang=ts"
export * from "./ProgramSupportCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports